import script from "./KnowledgeView.vue?vue&type=script&setup=true&lang=js"
export * from "./KnowledgeView.vue?vue&type=script&setup=true&lang=js"

import "./KnowledgeView.vue?vue&type=style&index=0&id=345ce758&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-345ce758"]])

export default __exports__